import { navigate } from 'wouter-preact/use-browser-location'

import { application } from 'state/application'
import { emitSystemNotification } from 'state/system_notification'
import { shutdownMessaging } from 'state/events_messaging'
import { broadcastSignOut } from 'utils'

import { updateAuthState } from './state'
import { AuthState } from './types'

/**
 * Signs out the current user by:
 * - Resetting the application state to reflect the logout.
 * - Redirecting the user to the login.
 * - Shutdown the messaging system
 * - Broadcast a message to all open tabs to notify them of the sign out.
 * - Clear the localStorage
 */
export const signOut = async () => {
	try {
		// 1. Request sign out of the application
		application.peek().forManagingAccount().signOut()

		// 2. Shutdown the messaging system
		shutdownMessaging()

		// 3. Update the application state to unauthenticated
		updateAuthState(() => AuthState.unauthenticated)

		// 4. Broadcast a message to all open tabs to notify them of the sign out
		broadcastSignOut()

		// 5. Replace the current page with the login page
		navigate('/', { replace: true })

		// 6. Clear the localStorage
		localStorage.clear()
	} catch (error) {
		console.error('Failed to sign out:', error)

		emitSystemNotification({
			variant: 'error',
			title: 'Sign out failed',
			message: 'An error occurred while signing out. Please try again.',
			display: 'dialog'
		})
	}
}
